import { useEffect, useRef, useState } from 'react';

import { PickerTitle } from '@entities/period-picker/model/picker-title.enum';

import { IPeriodPickerItemProps } from '../../model/types';

export const usePeriodPickerItem = ({
    itemType,
    isPicked,
    itemData,
    onClickHandler,
}: IPeriodPickerItemProps) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const [inputEnable, setInputEnable] = useState(false);

    useEffect(() => {
        if (isPicked && itemData.id === PickerTitle.CHOOSE_PERIOD) {
            inputRef.current?.focus();
        }
    }, [isPicked, itemData]);

    const disableInput = () => {
        setInputEnable(false);
    };
    const enableInput = () => {
        setInputEnable(true);
    };

    const onPickerClick = () => {
        onClickHandler(itemData.id);
        if (itemType === 'input') enableInput();
        if (itemType === 'button') disableInput();
    };

    return {
        inputEnable,
        inputRef,
        onPickerClick,
        disableInput,
    };
};
